import React from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import { useAuth } from '../App';
import './AdminLayout.css';

function AdminLayout() {
  const { admin, adminLogout } = useAuth();
  const location = useLocation();

  return (
    <div className="admin-layout">
      {/* Admin Header */}
      <header className="admin-header">
        <div className="admin-header-content">
          <div className="admin-logo">
            <Link to="/admin">
              <h1>🔐 Admin Portal</h1>
            </Link>
          </div>

          <nav className="admin-nav">
            <Link
              to="/admin"
              className={`admin-nav-link ${location.pathname === '/admin' ? 'active' : ''}`}
            >
              Stranke
            </Link>
            <Link
              to="/admin/translations"
              className={`admin-nav-link ${location.pathname === '/admin/translations' ? 'active' : ''}`}
            >
              Prevodi
            </Link>
          </nav>

          <div className="admin-header-right">
            <span className="admin-email">{admin?.email}</span>
            <button onClick={adminLogout} className="admin-logout-btn">
              Odjava
            </button>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="admin-main-content">
        <Outlet />
      </main>

      {/* Footer */}
      <footer className="admin-footer">
        <p>Zlatarenta Admin Portal • auth.zlatarenta.com</p>
      </footer>
    </div>
  );
}

export default AdminLayout;

